import {Component, Input, OnInit} from "@angular/core";
import {FormControl} from "@angular/forms";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-make-primary-dialog',
    templateUrl: './make-primary-dialog.component.html',
    styleUrls: ['./make-primary-dialog.component.scss'],
    standalone: false
})
export class MakePrimaryDialogComponent implements OnInit {

  @Input() companyName: string;
  @Input() message: string;
  @Input() cancelButtonText: string;
  @Input() cancelButtonClass: string = 'ds-btn';
  @Input() ssl: any;
  @Input() pointed: any;
  @Input() isConnected: boolean = false;
  @Input() disableMakePrimary: boolean = false;

  public enableSSL: FormControl;
  constructor(
    public activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
    this.enableSSL = new FormControl(!this.ssl);
  }

  public confirm(): void {
    this.activeModal.close({enableSSL: this.enableSSL.value});
  }
}
